import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as bootstrap from 'bootstrap';
@Component({
    standalone: false,
  selector: 'full-page-modal-popup',
  templateUrl: './full-page-modal-popup.component.html',
  styleUrls: ['./full-page-modal-popup.component.css']
})
export class FullPageModalPopupComponent implements OnInit {

  @Input() title: string;

  constructor() { }

  ngOnInit(): void { }

  closeModal() {
    const modalElement = document.getElementById('fullPageModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance.hide();
    }
  }
}
